/**
 * custom-fields-store — campos disponíveis pra ConditionsBuilder (FEAT-V2-032).
 *
 * Consome `GET /api/v1/workflows/:slug/custom-fields` — combina canônicos
 * com custom (futura tabela workflow_custom_fields_schema).
 */

import { useQuery } from '@tanstack/react-query';

import { api, hasToken } from './api';

export type CustomFieldType =
  | 'text'
  | 'number'
  | 'select'
  | 'multiselect'
  | 'tags'
  | 'boolean'
  | 'date';

export interface CustomField {
  field: string;
  label: string;
  type: CustomFieldType;
  options?: Array<{ value: string; label: string }>;
  scope: 'canonical' | 'custom';
}

export function useCustomFields(workflowSlug: string | null) {
  return useQuery({
    queryKey: ['v1', 'workflows', workflowSlug, 'custom-fields'],
    queryFn: () =>
      api.get<CustomField[]>(
        `/api/v1/workflows/${encodeURIComponent(workflowSlug!)}/custom-fields`,
      ),
    enabled: hasToken() && !!workflowSlug,
    staleTime: 5 * 60_000,
  });
}
